<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import listPlugin from '@fullcalendar/list'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import moment from 'moment/moment'

export default {
	components: { FullCalendar },
	data() {
		return {
			title: 'Calendar',
			calendarWeekends: true,
			calendarPlugins: [
				dayGridPlugin,
				timeGridPlugin,
				interactionPlugin,
				bootstrapPlugin,
				listPlugin,
			],
			themeSystem: 'bootstrap',
			events: [],
			createModal: false,
			showmodal: false,
			eventModal: false,
			submitted: false,
			submit: false,
			newEventData: {},
			edit: {},
			deleteId: {},
			event: {
				title: '',
				category: '',
			},
			editevent: {
				editTitle: '',
			},
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {
		...mapActions('candidate', ['getConfirmSchedule']),
		/**
		 * Modal form submit
		 */
		handleSubmit() {
			this.submitted = true

			// stop here if form is invalid
			this.$v.$touch()
			if (this.$v.$invalid) {
				return
			} else {
				const title = this.event.title
				const category = this.event.category

				this.events = this.events.concat({
					id: this.events.length + 1,
					title,
					start: new Date(),
					end: new Date(),
					classNames: [category],
				})

				this.showmodal = false
				this.newEventData = {}
			}
			this.submitted = false
			this.event = {}
		},
		/**
		 * Hide modal along with form reset
		 */
		hideModal() {
			this.submitted = false
			this.showmodal = false
			this.event = {}
		},
		/**
		 * Edit event modal submit
		 */
		editSubmit() {
			this.submit = true
			const editTitle = this.editevent.editTitle
			this.edit.setProp('title', editTitle)
			this.eventModal = false
		},

		/**
		 * Delete event
		 */
		deleteEvent() {
			var deleteId = this.edit.id
			this.events = this.events.filter(
				(x) => '' + x.id !== '' + deleteId
			)
			this.eventModal = false
		},
		/**
		 * Modal open for add event
		 */
		dateClicked(info) {
			this.newEventData = info
			this.showmodal = true
		},
		/**
		 * Modal open for edit event
		 */
		editEvent(info) {
			this.edit = info.event
			this.editevent.editTitle = this.edit.title
			this.eventModal = true
		},
		/**
		 * Closes the modal
		 */
		closeModal() {
			this.eventModal = false
		},
	},
	beforeMount(){
		this.getConfirmSchedule().then(res => {
			var data = res.data
			let eventData = []
			for(var key in data){
				if(data[key]['applications'].length > 0){
					for (const application of data[key]['applications']) {
						if(application.schedule){
							var date = moment(application['schedule']['date_interview']).format('YYYY-MM-DD')
							eventData.push({
								id: application['schedule']['_id'],
								title: moment(new Date(date  + ' ' + application['schedule']['start_time'])).format('hh:mm A') + " - " + moment(new Date(date  + ' ' + application['schedule']['end_time'])).format('hh:mm A') + " " + data[key]['full_name'] + ' Interview',
								date,
								className: 'bg-warning text-white',
								datetime: moment(new Date(date  + ' ' + application['schedule']['start_time']))
							})
						}
					}
					let sortedEventData = eventData.sort(function(a, b) {
						var c = new Date(a.datetime);
						var d = new Date(b.datetime);
						return c-d;
					});
					let order = 1
					this.events = sortedEventData.map(obj => ({ ...obj, eventOrder : order++ }))
					console.log(this.events)
				}
			}
		})
	}
}
</script>
<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
								:eventOrder="['eventOrder']"
                ref="fullCalendar"
                default-view="dayGridMonth"
                :header="{
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                }"
                :button-text="{
                  today: 'Today',
                  month: 'Month',
                  week: 'Week',
                  day: 'Day',
                  list: 'List',
                  prev: 'Prev',
                  next: 'Next',
                }"
                :bootstrap-font-awesome="false"
                :editable="false"
                :droppable="false"
                :plugins="calendarPlugins"
                :events="events"
                :weekends="calendarWeekends"
                :theme-system="themeSystem"
                
                @eventClick="editEvent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
